import { Logo } from "./Logo";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-card/30" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Logo />
          <p className="mt-4 text-sm text-muted-foreground max-w-sm leading-relaxed">
            Copiveo aide à structurer les retours pédagogiques, suivre les progrès et comparer localement des passages. Aucune comparaison ne prouve une triche.
          </p>
          <p className="mt-6 text-xs text-muted-foreground flex items-center gap-1.5 flex-wrap">
            Créé avec <Heart className="w-3 h-3 text-[#F28C28]" fill="currentColor" /> par
            <Link to="/a-propos" className="text-foreground hover:text-[#1769E0] font-medium" data-testid="footer-creator-link">
              Karim El Gartet
            </Link>
            · Professeur d'Économie Gestion · Formateur IA et Automatisation
          </p>
          <p className="mt-2 text-xs text-muted-foreground">
            © {new Date().getFullYear()} Copiveo. Accès enseignant privé sur invitation. Assistance IA facultative et soumise à quotas.
          </p>
        </div>

        <div>
          <div className="font-heading font-semibold mb-3 text-sm">Produit</div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><a href="/" className="hover:text-foreground">Fonctionnalités</a></li>
            <li><a href="/atelier" className="hover:text-foreground">Mon espace privé</a></li>
            <li><a href="/" className="hover:text-foreground">Comparaison locale</a></li>
            <li><a href="/a-propos" className="hover:text-foreground">À propos du projet</a></li>
          </ul>
        </div>

        <div>
          <div className="font-heading font-semibold mb-3 text-sm">Le projet</div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/a-propos" className="hover:text-foreground" data-testid="footer-link-about">À propos</Link></li>
            <li><Link to="/mentions-legales" className="hover:text-foreground" data-testid="footer-link-legal">Mentions légales</Link></li>
            <li><a href="/mentions-legales" className="hover:text-foreground">Informations légales</a></li>
            <li><Link to="/dashboard" className="hover:text-foreground">Espace prof</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-4 text-xs text-muted-foreground flex flex-col sm:flex-row justify-between gap-2">
          <span>Conçu pour les enseignants. Le jugement pédagogique reste humain.</span>
          <span className="flex items-center gap-1">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            Services selon configuration
          </span>
        </div>
      </div>
    </footer>
  );
}
